import { IonicModule } from '@ionic/angular';
// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { CommonModule } from '@angular/common';
import { DownloadBtnComponent } from './download-btn.component';

@NgModule({
  imports: [IonicModule, CommonModule],
  declarations: [DownloadBtnComponent],
  exports: [DownloadBtnComponent],
})
export class DownloadBtnModule {}
